import React, { useContext, useState, useEffect } from 'react';
import StateContext from '../../StateContext';
import Axios from 'axios';
import { firestore } from '../../firebase';



function RateRecipe(props) {

    const rates = [1, 2, 3, 4, 5]
    const [rated, setRated] = useState(false)
    const [rateValue, setRateValue] = useState(0);
    const [ratings, setRatings] = useState()
    const [newRateValue, setNewRateValue] = useState(0);

    const [userRating, setUserRating] = useState(0)
    const [ratingId, setRatingId] = useState()

    const [userRatings, setUserRatings] = useState([])

    const [isLoading, setIsLoading] = useState(false);
    const [isRatingLoading, setIsRatingLoading] = useState(true)

    const [avgRatings, setAvgRatings] = useState(2.5)

    const appState = useContext(StateContext)

    useEffect(() => {

        async function isRated() {
            if (appState.userId) {
                setIsLoading(true)
                try {
                    const rateRef = firestore.collection("ratings");
                    rateRef.where("recipe_id", "==", props.recipeId).onSnapshot(({docs}) => {
                        const ratings = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setRatings(ratings);
                        
    
                        const isRated = ratings.filter(rating => {
                            
                            return rating.user_id === appState.userId
                        })
                        //console.log(isRated, "has user rated this recipe??")
                        if (isRated.length) {
                            setRated(true)
                            setRatingId(isRated[0].id)
                            setUserRating(isRated[0].rating)
                        } else {
                            setRated(false)
                        }
                        setUserRatings(isRated);
    
                        const totalRatings = ratings.map(rating => {
                            
                            return rating.rating
                        })
                        //console.log(totalRatings)
                        const totalRatingsValue = totalRatings.reduce((total, cur) => {
                            return total + cur;
                        }, 0)
                        //console.log(totalRatingsValue)
    
                        const avgRatingsRecipe = (totalRatingsValue / totalRatings.length).toFixed(2)
                        //console.log(avgRatingsRecipe)
                        
                        if (totalRatings.length > 0) {
                            setAvgRatings(avgRatingsRecipe)
                        } else {
                            setAvgRatings(2.5)
                        }
                        
                        setIsRatingLoading(false)
    
                    })
                } catch (error) {
                    //console.log(error)
                }
                setIsLoading(false)
    
            }
           
        }
        isRated()

    }, [props.recipeId, appState.userId])


    async function rateRecipe(e, value) {

        e.preventDefault()

        try {
            const rateRef = firestore.collection("ratings");

            const data = {
                rating: value,
                recipe_id: props.recipeId,
                user_id: appState.userId
            }

            rateRef.add(data)
            setRated(true)
        } catch (error) {
            
        }
    }

    async function updateRateRecipe(e, rateValue) {

        e.preventDefault()
        setRateValue(rateValue)

        if (ratingId) {
            console.log("Updating rating")
            try {
                setRated(false)
    
                setRated(true)
                setRateValue(rateValue)
    
                const data = {
                    rating: rateValue
                }
    
                const rateRef = firestore.collection("ratings").doc(ratingId);
                rateRef.update(data)
                
    
                
            } catch (error) {
                
            }
        } 


    }

    async function deleteRatingHandler(e) {
        e.preventDefault()
        try {
            const ratingId = userRatings[0].id 
            console.log(ratingId)
            const rateRef = firestore.collection("ratings").doc(ratingId);
            rateRef.delete();
            
        } catch (error) {
            //console.log("Not deleted")
        }
    }



    return (
        <div className="col-12">

            
            
            {rated ? 
                <>
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <p className="text-center">Your rating: {userRating}/5</p>
                        </div>
                        {rates.map((rate, index) => {
                            return (
                                <form key={index} onSubmit={(e) => {updateRateRecipe(e, rate)}}>
                                    <input type="hidden"  name="ratingValue" value={rate} />
                                    <button style={{backgroundColor: "transparent", border: "none"}}>
                                        <i className={rated && rateValue > index ? "fa fa-star text-warning" : "fa fa-star"}></i>
                                    
                                    </button>
                                </form>
                            )
                        })}
                    
                    </div>
                </>
            : 
                
                    <div className="row justify-content-center">
                        {rates.map((rate, index) => {
                            return (
                                <form key={index} onSubmit={(e) => rateRecipe(e, rate)}>
                                    <input type="hidden"  name="ratingValue" value={rate} />
                                    <button style={{backgroundColor: "transparent", border: "none"}}>
                                        <i className={avgRatings && avgRatings > index ? "fa fa-star text-warning" : "fa fa-star"}></i>
                                    </button>
                                    
                                </form>
                            )
                        })}
                        
                    </div>  
                    
                
            }

            
            <div className="row justify-content-center my-2">
                {isRatingLoading ? <span>Laster ratings...</span> 
                : 
                <>
                <span>{avgRatings ? avgRatings : 0}/5</span>
                </>}
            </div>
            {userRatings && userRatings.length > 0 && (
                <div className="text-center">
                    <button onClick={deleteRatingHandler}>Slett rating</button>
                </div>
            )}
        </div>
    )
}
export default RateRecipe